import $ from 'jquery'
import {
  prepareChessboard,
  loadNextConfiguration,
  validateMove, restrictMove,
  showMagnus,
  showCapturedPieces,
  hideCapturedPieces
} from '../../utils'
import ChessBoard from '../../components/chessBoard'
import {
  BLACK_INITIAL_MOVE,
  WHITE_INITIAL_MOVE,
  BLACK_PIECE_SEARCH_KEY,
  WHITE_PIECE_SEARCH_KEY,
  ACTIVITY_SUCCESS_AUDIO,
  CORRECT_ANSWER_AUDIO,
  ACTIVITY_COMPLETION_AUDIO
} from '../../utils/constants'

var moveCount;

/**
* @name lesson6Assignment1
* @function
* @param {config}
* @description: chess board related task
*/
export function lesson6Assignment1(config) {
  let next = config.next,
    initialBoardPosition = config.position,
    firstLevelBoardPosition = '8/8/4R3/8/8/8/8/8';

  let afterLoad = function () {
    let prefilledCoordinates = config.prefilledCoordinates;

    prepareChessboard(config);
    moveCount = 0;

    prefilledCoordinates.map((k) => {
      return $(k).addClass('filled-square');
    })
  }

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    return validateMove(source, target);
  }

  var onSnapEnd = function (source, target) {
    let boardFen = ChessBoard.board.fen();

    moveCount++;
    if (moveCount === 2) {
      if (target === 'e6') {
        $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO)
        $('.square-e6').addClass('success');
      } else {
        moveCount = 0;

        showMagnus({
          data: 'Oops...!!!<br/> Try again',
          position: 'left',
          styleClass: 'xs'
        })

        $('.square-55d63').addClass('no-action');

        setTimeout(function () {
          $(document).trigger('bubble-hide');
          $('.square-55d63').removeClass('no-action');
          ChessBoard.board.position(initialBoardPosition);
          ChessBoard.game = new window.Chess(initialBoardPosition + WHITE_INITIAL_MOVE);
          return 'snapback';
        }, 4000)
      }
    } else if (moveCount === 4) {
      if (target === 'a7') {
        $('.square-a7').addClass('success');
        $(document).trigger('audio-play', ACTIVITY_SUCCESS_AUDIO);
        loadNextConfiguration(3500, next, true)
      } else {
        moveCount = 2;

        showMagnus({
          data: 'Oops...!!!<br/> Keep trying...',
          position: 'left',
          styleClass: 'xs'
        })

        $('.square-55d63').addClass('no-action');

        setTimeout(function () {
          $(document).trigger('bubble-hide');
          $('.square-55d63').removeClass('no-action');
          ChessBoard.board.position(firstLevelBoardPosition);
          ChessBoard.game = new window.Chess(firstLevelBoardPosition + WHITE_INITIAL_MOVE);
          return 'snapback';
        }, 4000)
      }
    }
    ChessBoard.game = new window.Chess(boardFen + WHITE_INITIAL_MOVE);
  };

  const chessConfig = {
    config: {
      position: initialBoardPosition,
      onDrop: onDrop,
      onSnapEnd: onSnapEnd,
      draggable: true,
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}

/**
* @name lesson6Assignment2
* @function
* @param {config}
* @description: chess board related task
*/
export function lesson6Assignment2(config) {
  let next = config.next;

  let afterLoad = function () {
    prepareChessboard(config);
  }

  let onDragStart = function (source, piece, position, orientation) {
    return restrictMove(piece, BLACK_PIECE_SEARCH_KEY)
  }

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    let move = ChessBoard.game.move({ from: source, to: target });

    if (move === null) {
      return 'snapback';
    } else {
      if (!move.captured) {
        ChessBoard.game = new window.Chess(ChessBoard.board.fen() + WHITE_INITIAL_MOVE);
        return 'snapback';
      } else {
        showCapturedPieces(piece, move)
      }
    }
  }

  var onSnapEnd = function (source, target) {
    if (target === 'd7') {
      $(document).trigger('audio-play', ACTIVITY_COMPLETION_AUDIO);
      loadNextConfiguration(3500, next)
    }

    ChessBoard.game = new window.Chess(ChessBoard.board.fen() + WHITE_INITIAL_MOVE);
  };

  const chessConfig = {
    config: {
      position: config.position,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onSnapEnd: onSnapEnd,
      draggable: true,
      sparePieces: true
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}

/**
* @name lesson6Assignment3
* @function
* @param {config}
* @description: chess board related task
*/
export function lesson6Assignment3(config) {
  let next = config.next,
    initialBoardPosition = config.position,
    tryCount = 0,
    timeDelay = 2000;

  let afterLoad = function () {
    prepareChessboard(config);
    tryCount = 0
  }

  let onDragStart = function (source, piece, position, orientation) {
    return restrictMove(piece, WHITE_PIECE_SEARCH_KEY)
  }

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    let move = ChessBoard.game.move({ from: source, to: target });

    if (move === null) {
      return 'snapback';
    } else {
      if (!move.captured) {
        ChessBoard.game = new window.Chess(ChessBoard.board.fen() + BLACK_INITIAL_MOVE);
        return 'snapback';
      } else {
        showCapturedPieces(piece, move)
      }
    }
  }

  var onSnapEnd = function (source, target) {
    if (target === 'f7' && $('.chessboard-63f37').find('.piece-417db').length === 1) {
      $(document).trigger('audio-play', ACTIVITY_COMPLETION_AUDIO);
      loadNextConfiguration(3500, next)
    }

    if (
      (target === 'f7' && $('.chessboard-63f37').find('.piece-417db').length > 1) ||
      (target === 'h6' && $('.chessboard-63f37 .square-c6').find('.piece-417db').length === 0) ||
      (target === 'a3' && $('.chessboard-63f37 .square-c3').find('.piece-417db').length === 0 && $('.chessboard-63f37 .square-f3').find('.piece-417db').length === 0)
    ) {
      
      $('.square-55d63').addClass('no-action');

      let magnusMsg = "";
      tryCount = tryCount + 1;

      if (tryCount <= 1) {
        showMagnus({
          data: 'Oops...!!!<br/> Try again',
          position: 'left',
          styleClass: 'xs'
        })
        timeDelay = 4000
      } else {
        timeDelay = 1000
      }

      if (tryCount > 1) {
        magnusMsg = "Follow this path...<br/> h6-c6-c3-a3-f3-f2-d2-d7-f7.";
      } else {
        magnusMsg = "Here's a hint...<br/>the White King is the last piece you will capture."
      }

      setTimeout(function () {
        showMagnus({
            data: magnusMsg,
            position: 'left',
            styleClass: 'lg'
        });
        
        
        hideCapturedPieces();
        $('.square-55d63').removeClass('no-action');
        ChessBoard.board.position(initialBoardPosition);
        ChessBoard.game = new window.Chess(initialBoardPosition + BLACK_INITIAL_MOVE);
        return 'snapback';
      }, timeDelay)
    }

    ChessBoard.game = new window.Chess(ChessBoard.board.fen() + BLACK_INITIAL_MOVE);
  };

  const chessConfig = {
    config: {
      position: initialBoardPosition,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onSnapEnd: onSnapEnd,
      draggable: true,
      sparePieces: true
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}


// WEBPACK FOOTER //
// ./src/lessons/lesson_6/assignments.js